var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_28335)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.12891,
    y: 1.08643,
    width: 17.6613,
    height: 17.7062,
    fill: "url(#pattern1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52734 18.2455L2.72089 13.8994C1.98702 12.6278 1.59589 11.1831 1.59992 9.70626C1.59992 5.07849 5.37412 1.31592 10.0112 1.31592C12.2612 1.31592 14.3741 2.18916 15.9588 3.77467C17.5475 5.36018 18.4225 7.46884 18.4185 9.71028C18.4185 14.3381 14.6443 18.1006 10.0072 18.1006H10.0031C8.59589 18.1006 7.21283 17.7465 5.98299 17.0785L1.52734 18.2455ZM6.19267 15.5574L6.4467 15.7103C7.51928 16.3461 8.74912 16.6801 10.0031 16.6841H10.0072C13.858 16.6841 16.9951 13.5574 16.9951 9.71028C16.9951 7.84711 16.2693 6.0966 14.9507 4.77668C13.6322 3.45676 11.8741 2.73242 10.0072 2.73242C6.15234 2.73242 3.01525 5.85918 3.01525 9.70626C3.01525 11.0222 3.38218 12.3059 4.0838 13.4165L4.24912 13.6821L3.5475 16.2495L6.19267 15.5574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81836 17.9515L2.97159 13.7544C2.26191 12.527 1.88691 11.1306 1.88691 9.70607C1.88691 5.23927 5.53207 1.60547 10.0038 1.60547C12.1772 1.60547 14.2135 2.45054 15.7458 3.97971C17.278 5.50889 18.1208 7.54511 18.1208 9.7101C18.1208 14.1769 14.4756 17.8107 10.0038 17.8107H9.99981C8.64094 17.8107 7.30626 17.4686 6.12078 16.8248L1.81836 17.9515Z",
    fill: "url(#paint0_linear_2006_28335)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.00781,
    y: 0.845215,
    width: 17.9032,
    height: 17.9477,
    fill: "url(#pattern2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52734 18.2455L2.72089 13.8994C1.98702 12.6278 1.59589 11.1831 1.59992 9.70626C1.59992 5.07849 5.37412 1.31592 10.0112 1.31592C12.2612 1.31592 14.3741 2.18916 15.9588 3.77467C17.5475 5.36018 18.4225 7.46884 18.4185 9.71028C18.4185 14.3381 14.6443 18.1006 10.0072 18.1006H10.0031C8.59589 18.1006 7.21283 17.7465 5.98299 17.0785L1.52734 18.2455ZM6.19267 15.5574L6.4467 15.7103C7.51928 16.3461 8.74912 16.6801 10.0031 16.6841H10.0072C13.858 16.6841 16.9951 13.5574 16.9951 9.71028C16.9951 7.84711 16.2693 6.0966 14.9507 4.77668C13.6322 3.45676 11.8741 2.73242 10.0072 2.73242C6.15234 2.73242 3.01525 5.85918 3.01525 9.70626C3.01525 11.0222 3.38218 12.3059 4.0838 13.4165L4.24912 13.6821L3.5475 16.2495L6.19267 15.5574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.24219,
    y: 5.39258,
    width: 9.55645,
    height: 8.9336,
    fill: "url(#pattern3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90763 6.19334C7.75038 5.84324 7.58505 5.8352 7.43586 5.83117C7.31489 5.82715 7.17376 5.82715 7.03263 5.82715C6.89151 5.82715 6.6657 5.87946 6.47215 6.08872C6.2786 6.29797 5.73828 6.80501 5.73828 7.83922C5.73828 8.8694 6.49231 9.86739 6.59715 10.0082C6.70199 10.1491 8.0528 12.3342 10.1859 13.1752C11.9601 13.8754 12.323 13.7346 12.706 13.6984C13.0931 13.6622 13.948 13.1913 14.1254 12.7004C14.2988 12.2094 14.2988 11.7909 14.2463 11.7024C14.1939 11.6139 14.0528 11.5616 13.8431 11.4569C13.6334 11.3523 12.6012 10.8453 12.4076 10.7728C12.2141 10.7044 12.073 10.6682 11.9359 10.8774C11.7947 11.0867 11.3915 11.5575 11.2705 11.6984C11.1496 11.8392 11.0246 11.8553 10.8149 11.7507C10.6052 11.6461 9.92779 11.4247 9.12538 10.7084C8.50038 10.1531 8.07699 9.46497 7.95602 9.25572C7.83505 9.04646 7.94393 8.93379 8.04876 8.82916C8.14151 8.7366 8.25844 8.58369 8.36328 8.46296C8.46812 8.34224 8.50441 8.25371 8.57296 8.11286C8.64151 7.97202 8.60925 7.85129 8.55683 7.74666C8.50038 7.64606 8.09312 6.60783 7.90763 6.19334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2006_28335"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2006_28335"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2006_28335"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_2006_28335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2006_28335",
    x1: 9.97226,
    y1: 17.9512,
    x2: 9.97226,
    y2: 1.6054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_28335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2006_28335",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfAAAAHxCAYAAACS8O5DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2006_28335",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbYAAAG4CAYAAAApA8IAAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2006_28335",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbwAAAG+CAYAAADoeLHUAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_2006_28335",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO0AAADeCAYAAADRo4eMAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7fad9da0ba657a19128d9220163c79ed.svg";
export { ForwardRef as ReactComponent };